import React, { useState } from 'react';

const TeamCarousel = ({ content }) => {
  const [selectedMember, setSelectedMember] = useState(null);

  const openModal = (member) => {
    setSelectedMember(member);
  };

  const closeModal = () => {
    setSelectedMember(null);
  };

  return (
    <div className="bg-white py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 id="team" className="text-3xl md:text-4xl font-bold font-crimson-text text-black">Notre Équipe d'Expertes</h2>
          <p className="font-biryani text-gray-600 text-lg mt-4 max-w-3xl mx-auto">
            Passionnées et à votre écoute, elles sauront vous conseiller et vous offrir des soins d'exception.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {content.items.map((item) => (
            <div key={item.user} onClick={() => openModal(item)} className="bg-gray-50 rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow cursor-pointer">
              <img className='w-32 h-32 rounded-full mx-auto mb-4 object-cover' src={item.img} alt={item.user} />
              <h3 className='font-poppins text-xl font-semibold text-gray-800'>{item.user}</h3>
              <p className='font-biryani text-gray-600 mt-2 line-clamp-3'>{item.text}</p>
            </div>
          ))}
        </div>
      </div>

      {selectedMember && (
        <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4" onClick={closeModal}>
          <div className="bg-white rounded-lg shadow-2xl w-full max-w-md md:max-w-4xl mx-auto relative overflow-hidden" onClick={(e) => e.stopPropagation()}>
            <button onClick={closeModal} className="absolute top-2 right-3 text-white md:text-gray-500 hover:text-gray-800 text-3xl font-bold z-10">&times;</button>
            <div className="md:flex">
              <div className="md:w-1/2">
                <img src={selectedMember.img} alt={selectedMember.user} className="w-full h-64 md:h-full object-cover" />
              </div>
              <div className="md:w-1/2 p-6 flex flex-col justify-center">
                <h3 className="text-3xl font-bold font-poppins text-center mb-4">{selectedMember.user}</h3>
                <p className="font-biryani text-gray-700 text-center md:text-left">{selectedMember.text}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamCarousel;